import 'imagesloaded'
import 'slick-slider'
import $ from 'jquery'

const mediaQuery_atLeastTablet = window.matchMedia('(min-width: 768px)')
window.addEventListener('load', () => {
    console.log('Initializing global slick slider with thumbnails')
    $('.global__slider')
        .find('img')
        // @ts-ignore
        .imagesLoaded(function () {
            $('.global__sliderImg').each(function () {
                const src = $(this).find('img').attr('src')
                const alt = $(this).find('img').attr('alt')
                const img =
                    `<div class="global__thumbsItem">
                        <span class="zoomPanel">
                            <img src="${src}" alt="${alt}" />
                        </span>
                    </div>`
                $('.global__thumbs').append(img)
            })

            const thumbnailSlider = $('.global__thumbs')
            thumbnailSlider
                .on('init', function () {
                    setTimeout(function () {
                        thumbnailSlider.addClass('-loaded')
                    }, 300)
                })
                // @ts-ignore
                .slick({
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    variableWidth: !0,
                    dots: !1,
                    arrows: !1,
                    autoplay: !1,
                    infinite: !0,
                    centerMode: !0,
                    asNavFor: '.global__slider'
                }),
                $('.global__thumbs .slick-slide').on('click', function () {
                    const t = $(this).attr('data-slick-index')
                    // @ts-ignore
                    thumbnailSlider.slick('slickGoTo', t, !1)
                })
            const globalSlider = $('.global__slider')
            globalSlider
                .on('init', function () {
                    setTimeout(function () {
                        globalSlider.addClass('-loaded')
                    }, 300)
                })
                // @ts-ignore
                .slick({
                    dots: !1,
                    autoplay: !1,
                    variableWidth: !0,
                    infinite: !0,
                    centerPadding: '10.78em',
                    centerMode: !0,
                    prevArrow:
                        '<button class="slick-prev slick-arrow global__arw" type="button"><span class="arw">Previous Slide</span></button>',
                    nextArrow:
                        '<button class="slick-next slick-arrow global__arw" type="button"><span class="arw">Next Slide</span></button>',
                    asNavFor: '.global__thumbs'
                })
                globalSlider.find('.slick-arrow').hover(
                    function () {
                        if (mediaQuery_atLeastTablet.matches) {
                            if ($(this).hasClass('slick-next')) {
                                globalSlider.find('.slick-track').css('margin-left', '-20px')
                            }
                        }
                    },
                    function () {
                        if (mediaQuery_atLeastTablet.matches) {
                            if ($(this).hasClass('slick-next')) {
                                globalSlider.find('.slick-track').css('margin-left', 0)
                            }
                        }
                    }
                )
        })
})
